import NotifyMeModal from './NotifyMeModal'

export default NotifyMeModal
